/** 
 * @type {PlanReportsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    plan_ids: null,
    status: null,
    years: null,
}
/** 
* @returns {PlanReportsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/PlanReportsFilter.js